import styled from "styled-components";

export const AboutMeContainer = styled.div`
    margin-top: 60px;
`;
